import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';

import { RestangularModule } from 'ngx-restangular';
import { Router } from '@angular/router';
import { RestangularConfigFactory } from './shared/api/restangular-config.factory';
import { ErrorsModule } from './error/errors.module';
import { MomentModule } from 'ngx-moment';
import { AnonymousApplicationComponent } from './features/list/anonymous-application/anonymous-application.component';
import { ListModule } from './features/list/list.module';
import { ReferFriendComponent } from './features/list/refer-friend/refer-friend.component';


@NgModule({
  declarations: [
    AppComponent,    
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ErrorsModule,
    AppRoutingModule,
    SharedModule,
    CoreModule,
    MomentModule, 
    ListModule,
    RestangularModule.forRoot([Router], RestangularConfigFactory),
  ],
  providers: [],
  bootstrap: [AppComponent],
  entryComponents: [AnonymousApplicationComponent, ReferFriendComponent]
})
export class AppModule { }
